export default class ControlledAreaDefinition {
  behavior;
  displayName;
  group;
  groupSort;
  identifier;
  system;
  tile;
  type;
  toolbarDefault;

  constructor(apiControlledAreaDefinition) {
    if (!apiControlledAreaDefinition) return;

    this.behavior =
      typeof apiControlledAreaDefinition.behavior === "string"
        ? JSON.parse(apiControlledAreaDefinition.behavior)
        : apiControlledAreaDefinition.behavior;
    this.displayName = apiControlledAreaDefinition.displayName;
    this.group = apiControlledAreaDefinition.group;
    this.groupSort = apiControlledAreaDefinition.groupSort;
    this.identifier = apiControlledAreaDefinition.identifier;
    this.system = apiControlledAreaDefinition.system;
    this.tile = apiControlledAreaDefinition.tile;
    this.type = apiControlledAreaDefinition.type;
    this.toolbarDefault = apiControlledAreaDefinition.toolbarDefault;
  }
}
